import Pot from "../assets/imgs/pot_normal.svg";
import PotLit from "../assets/imgs/pot_lit.svg";
import PotTop from "../assets/imgs/pot_top_normal.png";
import Bowl from "../assets/imgs/bowl_normal.png";
import BowlLit from "../assets/imgs/bowl_lit.png";
import BowlTop from "../assets/imgs/bowl_top_normal.png";
import Intro from "../assets/imgs/intro_background.svg";

//Curry
import EnvHiro from "../assets/imgs/curry/environment_hiro.svg";
import CurryFridge from "../assets/imgs/curry/fridge.svg";
import CurryFridgeOpen from "../assets/imgs/curry/fridge_open.svg";
import CurryFridgeDoor from "../assets/imgs/curry/fridge_door.svg";
import CurryLowerCabinet from "../assets/imgs/curry/lower_cabinet.svg";
import CurryLowerCabinetOpen from "../assets/imgs/curry/lower_cabinet_open.svg";
import CurryLowerCabinetDoor from "../assets/imgs/curry/lower_cabinet_door.svg";
import CurrySink from "../assets/imgs/curry/sink_cabinet.svg";
import CurrySinkOpen from "../assets/imgs/curry/sink_cabinet_open.svg";
import CurrySinkDoor from "../assets/imgs/curry/sink_cabinet_door.svg";
import CurryUpperCabinet from "../assets/imgs/curry/upper_cabinet.svg";
import CurryUpperCabinetOpen from "../assets/imgs/curry/upper_cabinet_open.svg";
import CurryUpperCabinetDoor from "../assets/imgs/curry/upper_cabinet_door.svg";
import Apple from "../assets/imgs/curry/apple_slice.svg";
import AppleMag from "../assets/imgs/curry/appleSlices_mag.svg";
import Potato from "../assets/imgs/curry/potato.svg";
import Curry from "../assets/imgs/curry/curry.svg";
import Carrot from "../assets/imgs/curry/half_carrot.svg";
import Banana from "../assets/imgs/curry/banana.svg";
import BananaMag from "../assets/imgs/curry/bruisedBanana_mag.svg";
import Recipe from "../assets/imgs/curry/recipe_book.svg";
import HiroHuman from "../assets/imgs/curry/hiro_human.png";
import HiroHalfZombie from "../assets/imgs/curry/hiro_half_zombie.png";
import HiroZombie from "../assets/imgs/curry/hiro_zombie.png";
import CurryRecipe from "../assets/imgs/curry/recipe.svg";

//Salad
import EnvMatt from "../assets/imgs/salad/environment_matt.svg";
import SaladCabinet from "../assets/imgs/salad/cabinet.svg";
import SaladFridge from "../assets/imgs/salad/fridge.svg";
import SaladSink from "../assets/imgs/salad/kitchen_sink.svg";
import SaladLargeCabinet from "../assets/imgs/salad/large_cabinet.svg";
import SaladCabinetOpen from "../assets/imgs/salad/cabinet_open.svg";
import SaladFridgeOpen from "../assets/imgs/salad/fridge_open.svg";
import SaladSinkOpen from "../assets/imgs/salad/kitchen_sink_open.svg";
import SaladLargeCabinetOpen from "../assets/imgs/salad/large_cabinet_open.svg";
import Eggs from "../assets/imgs/salad/eggs.svg";
import Honey from "../assets/imgs/salad/honey.svg";
import Kiwi from "../assets/imgs/salad/kiwi.svg";
import Oil from "../assets/imgs/salad/oil.svg";
import OilMag from "../assets/imgs/salad/oil_mag.svg";
import Spinach from "../assets/imgs/salad/spinach.svg";
import SpinachMag from "../assets/imgs/salad/spinach_mag.svg";
import Vinegar from "../assets/imgs/salad/vinegar.svg";
import Bread from "../assets/imgs/salad/bread.svg";
import MattHuman from "../assets/imgs/salad/matt_human.png";
import MattHalfZombie from "../assets/imgs/salad/matt_half_zombie.png";
import MattZombie from "../assets/imgs/salad/matt_zombie.png";
import SaladRecipe from "../assets/imgs/salad/recipe.svg";

//Pizza
import EnvRoommate from "../assets/imgs/pizza/Environment-Roommate.svg";
import PizzaFridgeOpen from "../assets/imgs/pizza/fridge_open.svg";
import PizzaFridge from "../assets/imgs/pizza/fridge.svg";
import PizzaUpperCabinetOpen from "../assets/imgs/pizza/upper_cabinet_open.svg";
import PizzaUpperCabinet from "../assets/imgs/pizza/upper_cabinet.svg";
import PizzaSinkOpen from "../assets/imgs/pizza/sink_cabinet_open.svg";
import PizzaSink from "../assets/imgs/pizza/sink_cabinet.svg";
import PizzaMiddleCabinetOpen from "../assets/imgs/pizza/top_middle_cabinet_open.svg";
import PizzaMiddleCabinet from "../assets/imgs/pizza/top_middle_cabinet.svg";
import Cheese from "../assets/imgs/pizza/Cheese.svg";
import Dough from "../assets/imgs/pizza/dough.svg";
import Pumpkin from "../assets/imgs/pizza/pumpkin.svg";
import PumpkinMag from "../assets/imgs/pizza/pumpkin_mag.svg";
import Takeout from "../assets/imgs/pizza/takeout.svg";
import Pepperoni from "../assets/imgs/pizza/pepperoni.svg";
import PepperoniMag from "../assets/imgs/pizza/pepperoni_mag.svg";
import Tomato from "../assets/imgs/pizza/tomato.svg";
import EmmaHuman from "../assets/imgs/pizza/roommate1.png";
import EmmaHalfZombie from "../assets/imgs/pizza/roommate2.png";
import EmmaZombie from "../assets/imgs/pizza/roommate3.png";
import PizzaRecipe from "../assets/imgs/pizza/recipe.svg";

const images = {
  Pot: Pot,
  PotLit: PotLit,
  PotTop: PotTop,
  Bowl: Bowl,
  BowlLit: BowlLit,
  BowlTop: BowlTop,
  Intro: Intro,

  //Curry - Hiro
  Apple: Apple,
  AppleMag: AppleMag,
  Potato: Potato,
  Curry: Curry,
  Carrot: Carrot,
  Banana: Banana,
  BananaMag: BananaMag,
  Recipe: Recipe,
  EnvHiro: EnvHiro,
  CurryFridge: CurryFridge,
  CurryFridgeOpen: CurryFridgeOpen,
  CurryFridgeDoor: CurryFridgeDoor,
  CurryLowerCabinet: CurryLowerCabinet,
  CurryLowerCabinetOpen: CurryLowerCabinetOpen,
  CurryLowerCabinetDoor: CurryLowerCabinetDoor,
  CurrySink: CurrySink,
  CurrySinkDoor: CurrySinkDoor,
  CurrySinkOpen: CurrySinkOpen,
  CurryUpperCabinet: CurryUpperCabinet,
  CurryUpperCabinetOpen: CurryUpperCabinetOpen,
  CurryUpperCabinetDoor: CurryUpperCabinetDoor,
  HiroHuman: HiroHuman,
  HiroHalfZombie: HiroHalfZombie,
  HiroZombie: HiroZombie,
  CurryRecipe: CurryRecipe,

  //Salad - Matt
  EnvMatt: EnvMatt,
  SaladCabinet: SaladCabinet,
  SaladFridge: SaladFridge,
  SaladSink: SaladSink,
  SaladLargeCabinet: SaladLargeCabinet,
  SaladCabinetOpen: SaladCabinetOpen,
  SaladFridgeOpen: SaladFridgeOpen,
  SaladSinkOpen: SaladSinkOpen,
  SaladLargeCabinetOpen: SaladLargeCabinetOpen,
  Eggs: Eggs,
  Honey: Honey,
  Kiwi: Kiwi,
  Oil: Oil,
  OilMag: OilMag,
  Spinach: Spinach,
  SpinachMag: SpinachMag,
  Vinegar: Vinegar,
  Bread: Bread,
  MattHuman: MattHuman,
  MattHalfZombie: MattHalfZombie,
  MattZombie: MattZombie,
  SaladRecipe: SaladRecipe,

  //Pizza - Emma
  PizzaFridgeOpen: PizzaFridgeOpen,
  PizzaFridge: PizzaFridge,
  PizzaUpperCabinetOpen: PizzaUpperCabinetOpen,
  PizzaUpperCabinet: PizzaUpperCabinet,
  PizzaSinkOpen: PizzaSinkOpen,
  PizzaSink: PizzaSink,
  PizzaMiddleCabinetOpen: PizzaMiddleCabinetOpen,
  PizzaMiddleCabinet: PizzaMiddleCabinet,
  Cheese: Cheese,
  Dough: Dough,
  Pumpkin: Pumpkin,
  PumpkinMag: PumpkinMag,
  Tomato: Tomato,
  Takeout: Takeout,
  Pepperoni: Pepperoni,
  PepperoniMag: PepperoniMag,
  EnvRoommate: EnvRoommate,
  EmmaHuman: EmmaHuman,
  EmmaHalfZombie: EmmaHalfZombie,
  EmmaZombie: EmmaZombie,
  PizzaRecipe: PizzaRecipe,
};

export default images;
